export interface Project {
  num: string;          // "01"
  slug: "hirestation" | "dirgahyu" | "purlieu" | "baatcheeth";
  title: string;        // "HireStation"
  domain: string;       // "hirestation.app"
  year: string;
  tag: string;          // "marketplace"
  description: string;
  stack: string[];
  liveUrl?: string;
  repoUrl?: string;
  accent: string;       // hex used in the screenshot
}

export const projects: Project[] = [
  {
    num: "01",
    slug: "hirestation",
    title: "HireStation",
    domain: "hirestation.app",
    year: "2023",
    tag: "marketplace",
    description:
      "A two-sided marketplace for buying and selling digital services with Stripe-powered payments.",
    stack: ["React", "Express", "MongoDB", "Stripe"],
    liveUrl: "https://hirestation.vercel.app/",
    repoUrl: "https://github.com/iamsumanp/hirestationfrontend",
    accent: "#6c5ce7",
  },
  {
    num: "02",
    slug: "dirgahyu",
    title: "Dirgahyu",
    domain: "dirgahyu.app",
    year: "2024",
    tag: "directory",
    description:
      "A Nepal-wide directory of hospitals and blood-donation centers, with request flows and donation resources.",
    stack: ["Next.js", "React", "Tailwind"],
    liveUrl: "https://dirgahyu.vercel.app/",
    repoUrl: "https://github.com/iamsumanp/dirgahyu",
    accent: "#e74c3c",
  },
  {
    num: "03",
    slug: "purlieu",
    title: "Purlieu",
    domain: "purlieu.app",
    year: "2022",
    tag: "fintech",
    description:
      "Digitizes university canteen card recharges with an integrated online payment flow.",
    stack: ["React", "StyledComponents", "PostgreSQL"],
    liveUrl: "https://purlieu-users-front.vercel.app/",
    repoUrl: "https://github.com/shresthaoshan/purlieu_users_frontend",
    accent: "#a78bfa",
  },
  {
    num: "04",
    slug: "baatcheeth",
    title: "BaatCheeth",
    domain: "baatcheeth.app",
    year: "2022",
    tag: "chat",
    description:
      "Realtime chat with channels and message moderation, backed by Firebase.",
    stack: ["React", "Firebase"],
    liveUrl: "https://baatcheeth.vercel.app/",
    repoUrl: "https://github.com/iamsumanp/BaatCheeth",
    accent: "#7ee787",
  },
];
